<template>
  <panel title="Categoria">
    <loader :loading="loading"/>

    <div slot="header-right" v-if="categoryNotFound" class="hint hint--left icon-category-not-found" data-label="Não foi possível utilizar a predefinição configurada, por favor acesse as predefinições e realize a correção no item indicado.">
      <i class="icon-warning2 t-warning"></i>
    </div>

    <div class="l-row">
      <form-group :label="`${$t('category.label')} ${$t('level.label')} ${(index + 1)}`" :columns="4" v-for="(categories, index) in categories" :key="categories" :error="product.categories[index] === null && getError('categories', product.productId)">
        <select class="form-select" v-model="product.categories[index]" @change="getCategoryChildren(index)">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option v-for="category in categories" :key="category" :value="category.id">{{ category.name }}</option>
        </select>
      </form-group>
    </div>
  </panel>
</template>

<script>
  import { mapGetters } from 'vuex'
  import api from '@/api'
  import notifier from '@/notifier'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import Loader from '@/components/template/Loader'

  export default {
    data: () => ({
      categories: [],
      categoryNotFound: false,
      loading: true
    }),
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      try {
        const accountId = await api.mercadoLivre.getActiveAccountId()
        this.categories.push(await api.mercadoLivre.getCategories(accountId))
      } catch (err) {
        notifier.error('Impossível carregar as categorias do Mercado Livre.', 'Erro')
      }

      const presetCategorization = this.$parent.$parent.getPresetItemsCategorization(this.product.categories)

      this.product.categories = []
      if (presetCategorization !== null && presetCategorization !== undefined) {
        const categories = presetCategorization.categories

        this.product.categories = categories
        for (const i in categories) {
          if (this.categoryNotFound) {
            this.categories.splice(1, this.categories.length)
            this.product.categories = [null]

            break
          }
          await this.getCategoryByIndex(i)
        }
      }

      this.loading = false
    },
    methods: {
      async getCategoryChildren (index) {
        if (this.product.categories[index] === null) {
          return false
        }

        this.$emit('loading', true)

        if (index <= (this.categories.length - 1)) {
          this.categories.splice(index + 1, this.categories.length)
          this.product.categories.splice(index + 1, this.product.categories.length)
        }

        await this.getCategoryByIndex(index)
      },
      async getCategoryByIndex (index) {
        try {
          const accountId = await api.mercadoLivre.getActiveAccountId()
          this.categories.push(await api.mercadoLivre.getCategories(accountId, this.product.categories[index]))
          this.$emit('change')
        } catch (err) {
          if (err.response.status === 400) {
            this.categoryNotFound = true
            return
          }

          if (err.response.status !== 404) {
            notifier.error('Impossível carregar os tipos de produto do Mercado Livre.', 'Erro')
            return
          }

          if (err.response.status === 404 && !this.categoryNotFound) {
            this.$emit('searchCategoryInfo', this.product.categories.slice(-1)[0])
          }
        }

        this.$emit('loading', false)
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    watch: {
      categories (value) {
        for (let i in value) {
          let category = this.product.categories[i]

          if (category === undefined) {
            this.product.categories[i] = null
          }
        }
      }
    },
    components: {
      Panel,
      FormGroup,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Category.vue?7237f42a